// import Swiper from "swiper"
import { find } from "../utils/dom"

export default function () {
	const Home = find("[js-page='yoga-programs']")
	if (!Home) return
	console.log('Page Yoga Programs');


var swiperYogaProgram = new Swiper(".swiper-yoga-program", {
	spaceBetween: 24,
	slidesPerView: 'auto',

	navigation: {
		nextEl: ".swiper-button-yoga-program-next",
		prevEl: ".swiper-button-yoga-program-prev",
	},
});
}